// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QuestViewModal — Amber/brown branded quest detail modal */

.quest-view-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  animation: qFadeIn 0.2s ease;
}

.quest-view-modal {
  background: #fff;
  border-radius: 16px;
  width: 90vw;
  max-width: 820px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  animation: qSlideUp 0.25s ease;
  overflow: hidden;
}

/* Header — amber/brown gradient */
.quest-modal-header {
  background: linear-gradient(135deg, #A8890A 0%, #7C6608 100%);
  padding: 24px 28px 20px;
  color: #fff;
  position: relative;
}

.quest-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1A5F7A, #3397AB, #1A5F7A);
}

.quest-modal-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.3;
}

.quest-modal-meta-bar {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.quest-modal-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.8rem;
  opacity: 0.9;
}

.quest-modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.quest-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.quest-modal-status {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.quest-modal-status--completed {
  background: rgba(20, 97, 82, 0.3);
  color: #a7f3d0;
}

.quest-modal-status--draft {
  background: rgba(255, 255, 255, 0.2);
  color: #FFF3CC;
}

.quest-modal-status--processing {
  background: rgba(26, 95, 122, 0.3);
  color: #93c5fd;
}

/* Quest Prompt Banner */
.quest-prompt-banner {
  background: linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 100%);
  border: 1px solid #FFE799;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.quest-prompt-banner-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  color: #A8890A;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 6px;
}

.quest-prompt-banner-text {
  font-family: 'Playfair Display', serif;
  font-size: 1.05rem;
  color: #504405;
  line-height: 1.5;
  font-style: italic;
}

/* XP Badge */
.quest-xp-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #D4AC0D 0%, #FFCF33 100%);
  color: #504405;
  padding: 4px 12px;
  border-radius: 16px;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
}

/* Body */
.quest-modal-body {
  padding: 24px 28px;
  overflow-y: auto;
  flex: 1;
}

/* Creation Steps Timeline (quest uses brown accents) */
.quest-steps-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #A8890A;
  margin: 0 0 16px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.quest-steps-timeline {
  position: relative;
  padding-left: 32px;
}

.quest-steps-timeline::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 4px;
  bottom: 4px;
  width: 2px;
  background: linear-gradient(to bottom, #A8890A, #1A5F7A);
  border-radius: 1px;
}

.quest-step {
  position: relative;
  padding-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.quest-step:last-child {
  padding-bottom: 0;
}

.quest-step-dot {
  position: absolute;
  left: -32px;
  top: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #A8890A;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 0.6rem;
  font-weight: 700;
  color: #A8890A;
}

.quest-step-dot--filled {
  background: #A8890A;
  color: #fff;
}

.quest-step-dot--teal {
  border-color: #1A5F7A;
  background: #1A5F7A;
  color: #fff;
}

.quest-step-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6C757D;
  min-width: 120px;
}

.quest-step-value {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  color: #212529;
  font-weight: 500;
  text-transform: capitalize;
}

.quest-step-value--empty {
  color: #ADB5BD;
  font-style: italic;
}

/* Content comparison */
.quest-content-section {
  margin-top: 24px;
}

.quest-content-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #A8890A;
  margin: 0 0 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.quest-content-comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.quest-content-comparison--single {
  grid-template-columns: 1fr;
}

.quest-content-box {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 16px;
  max-height: 200px;
  overflow-y: auto;
}

.quest-content-box-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  color: #6C757D;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.quest-content-box-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.875rem;
  line-height: 1.65;
  color: #374151;
  white-space: pre-wrap;
}

/* Footer */
.quest-modal-footer {
  padding: 16px 28px;
  border-top: 1px solid #E5E7EB;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Animations */
@keyframes qFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes qSlideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/content/QuestViewModal.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;AACT;;AAEA,uDAAuD;AACvD;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/* QuestViewModal — Amber/brown branded quest detail modal */\n\n.quest-view-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1300;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  animation: qFadeIn 0.2s ease;\n}\n\n.quest-view-modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 90vw;\n  max-width: 820px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  animation: qSlideUp 0.25s ease;\n  overflow: hidden;\n}\n\n/* Header — amber/brown gradient */\n.quest-modal-header {\n  background: linear-gradient(135deg, #A8890A 0%, #7C6608 100%);\n  padding: 24px 28px 20px;\n  color: #fff;\n  position: relative;\n}\n\n.quest-modal-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #1A5F7A, #3397AB, #1A5F7A);\n}\n\n.quest-modal-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 8px;\n  line-height: 1.3;\n}\n\n.quest-modal-meta-bar {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.quest-modal-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n.quest-modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.quest-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.quest-modal-status {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.quest-modal-status--completed {\n  background: rgba(20, 97, 82, 0.3);\n  color: #a7f3d0;\n}\n\n.quest-modal-status--draft {\n  background: rgba(255, 255, 255, 0.2);\n  color: #FFF3CC;\n}\n\n.quest-modal-status--processing {\n  background: rgba(26, 95, 122, 0.3);\n  color: #93c5fd;\n}\n\n/* Quest Prompt Banner */\n.quest-prompt-banner {\n  background: linear-gradient(135deg, #FFF9E6 0%, #FFF3CC 100%);\n  border: 1px solid #FFE799;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n}\n\n.quest-prompt-banner-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #A8890A;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 6px;\n}\n\n.quest-prompt-banner-text {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.05rem;\n  color: #504405;\n  line-height: 1.5;\n  font-style: italic;\n}\n\n/* XP Badge */\n.quest-xp-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #D4AC0D 0%, #FFCF33 100%);\n  color: #504405;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n/* Body */\n.quest-modal-body {\n  padding: 24px 28px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Creation Steps Timeline (quest uses brown accents) */\n.quest-steps-title {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #A8890A;\n  margin: 0 0 16px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.quest-steps-timeline {\n  position: relative;\n  padding-left: 32px;\n}\n\n.quest-steps-timeline::before {\n  content: '';\n  position: absolute;\n  left: 11px;\n  top: 4px;\n  bottom: 4px;\n  width: 2px;\n  background: linear-gradient(to bottom, #A8890A, #1A5F7A);\n  border-radius: 1px;\n}\n\n.quest-step {\n  position: relative;\n  padding-bottom: 16px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.quest-step:last-child {\n  padding-bottom: 0;\n}\n\n.quest-step-dot {\n  position: absolute;\n  left: -32px;\n  top: 2px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  border: 2px solid #A8890A;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  font-size: 0.6rem;\n  font-weight: 700;\n  color: #A8890A;\n}\n\n.quest-step-dot--filled {\n  background: #A8890A;\n  color: #fff;\n}\n\n.quest-step-dot--teal {\n  border-color: #1A5F7A;\n  background: #1A5F7A;\n  color: #fff;\n}\n\n.quest-step-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6C757D;\n  min-width: 120px;\n}\n\n.quest-step-value {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.875rem;\n  color: #212529;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.quest-step-value--empty {\n  color: #ADB5BD;\n  font-style: italic;\n}\n\n/* Content comparison */\n.quest-content-section {\n  margin-top: 24px;\n}\n\n.quest-content-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #A8890A;\n  margin: 0 0 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.quest-content-comparison {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.quest-content-comparison--single {\n  grid-template-columns: 1fr;\n}\n\n.quest-content-box {\n  background: #F9FAFB;\n  border: 1px solid #E5E7EB;\n  border-radius: 12px;\n  padding: 16px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.quest-content-box-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #6C757D;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 8px;\n}\n\n.quest-content-box-text {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 0.875rem;\n  line-height: 1.65;\n  color: #374151;\n  white-space: pre-wrap;\n}\n\n/* Footer */\n.quest-modal-footer {\n  padding: 16px 28px;\n  border-top: 1px solid #E5E7EB;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Animations */\n@keyframes qFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes qSlideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
